import { Controller } from "@hotwired/stimulus"
import { get, post, put, patch, destroy } from '@rails/request.js'
import slugify  from 'slugify'

export default class extends Controller {
  static targets = [ "slug", "title" ]

  connect() {
    document.addEventListener("turbo:submit-start", (event) => {
      console.log(event)
      confirmSubmission(event).then(() => {
        // show progress bar and set submit state here.
        // this block is optional.
      })
    })

    function confirmSubmission(event) {
      const button = event.target.querySelector("[data-confirm]")
      const message = button?.dataset?.confirm

      return new Promise(resolve => {
        if (!message || confirm(message)) {
          resolve()
        } else {
          event.detail.formSubmission.stop()
          event.preventDefault()
          event.stopImmediatePropagation()
        }
      })
    }
  }

  disconnect() {
  }


  updateSlug() {
    this.slugTarget.value = slugify(this.titleTarget.value, { lower: true, strict: true })
  }

  expandTree (event) {
    const currentCategory = document.getElementById(`tree-category-${event.params.categoryId}`)
    const subtree = currentCategory.querySelector('ul')
    if (subtree.classList.contains('hidden')) {
      subtree.classList.remove('hidden')
      currentCategory.querySelector('.expand-button').classList.add('hidden')
      currentCategory.querySelector('.collapse-button').classList.remove('hidden')
    } else {
      subtree.classList.add('hidden')
      currentCategory.querySelector('.expand-button').classList.remove('hidden')
      currentCategory.querySelector('.collapse-button').classList.add('hidden')
    }

    this.selectCategory(event)
  }

  async selectCategory(event) {
    const currentCategory = document.getElementById(`tree-category-${event.params.categoryId}`)
    document.getElementById('tree-category').querySelectorAll('.category-link-active').forEach((el) => { el.classList.add('hidden') })
    document.getElementById('tree-category').querySelectorAll('.category-link-inactive.hidden').forEach((el) => { el.classList.remove('hidden') })
    currentCategory.querySelector('.category-link-inactive').classList.add('hidden')
    currentCategory.querySelector('.category-link-active').classList.remove('hidden')

    await get(`/admin/categories/${event.params.categoryId}/edit`, {
      responseKind: 'turbo-stream'
    })
  }

  async newCategory(event) {
    if (event.params.categoryId) {
      console.log(event.params.categoryId)
      await get(`/admin/categories/new?category_id=${event.params.categoryId}`, {
        responseKind: 'turbo-stream'
      })
    } else {
      await get(`/admin/categories/new`, {
        responseKind: 'turbo-stream'
      })
    }
  }
}
